import React, { useState } from 'react'
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { uploadCCFPointsAPI } from '../../apiConfig/apiCall';
import { toast } from 'react-toastify';
import SampleCSVFileForCCFUpload from '../../csvFiles/ccf-sample.csv'
import { useDispatch } from 'react-redux';
import { getCCFPoints } from '../../slices/ManageCCFPoints/thunk';

export default function UploadCCFModal({ uploadCertificateModal, setUploadCertificateModal, toggleUploadCertificateModal }) {

    const dispatch = useDispatch();

    const [csvFile, setCsvFile] = useState(null);
    const handleDownloadSampleFile = () => {
        const link = document.createElement('a');
        link.href = SampleCSVFileForCCFUpload;
        link.download = 'ccf-sample.csv';
        link.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type === "text/csv" || file.name.endsWith(".csv")) {
                setCsvFile(file);
            } else {
                setCsvFile(null);
                toast.error("Please upload a valid CSV file.");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (csvFile) {
            const formData = new FormData();
            formData.append("file", csvFile);
            const apiResponse = await uploadCCFPointsAPI(formData);
            if (apiResponse.status === 200) {
                toast.success(apiResponse.data);
                setUploadCertificateModal(false);
                dispatch(getCCFPoints());
            } else {
                toast.error(apiResponse.data)
            }

        } else {
            toast.error("Please upload a valid CSV file before submitting.");
        }
    };
    return (
        <>
            <Modal isOpen={uploadCertificateModal} toggle={toggleUploadCertificateModal}>
                <ModalHeader toggle={toggleUploadCertificateModal}>
                    Upload CCF
                    <Button
                        color="primary"
                        className="waves-effect waves-light material-shadow-none mx-3"
                        outline
                        onClick={handleDownloadSampleFile}
                    >
                        <i className="ri-download-2-line me-2" />
                        Download Sample File
                    </Button>
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row className="gy-3">
                            <Col lg={12}>
                                <div>
                                    <Label htmlFor="csvFile" className="form-label">CSV File</Label>
                                    <Input
                                        type="file"
                                        className="form-control"
                                        id="csvFile"
                                        onChange={handleFileChange}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <Button color="primary" type="submit" className="me-2">Upload CCF</Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}
